export const handsOnExercises = {
  'aml-foundations': {
    'en': {
      id: 'aml-foundations-hands-on',
      title: 'AML Foundations Hands-On Exercise',
      tasks: [
        {
          id: 'task-1',
          title: 'Identify Suspicious Transaction Patterns',
          instructions: 'Using CrossRegGuard, navigate to the Transaction Monitoring page. Review the sample transactions provided and identify at least 2 transactions that appear suspicious based on AML indicators (unusual amounts, rapid movements, high-risk jurisdictions, etc.).',
          question: 'Which transaction IDs did you identify as suspicious, and what were the red flags?',
          crossregguardLink: '/app/transactionmonitoring'
        },
        {
          id: 'task-2',
          title: 'File a Suspicious Activity Report',
          instructions: 'For one of the suspicious transactions you identified, prepare and file a Suspicious Activity Report (SAR) using CrossRegGuard\'s reporting feature. Include details about the transaction, parties involved, and the AML concerns.',
          question: 'What was the transaction amount, the customer name, and the primary AML concern you reported?',
          crossregguardLink: '/app/sar'
        },
        {
          id: 'task-3',
          title: 'Review AML Compliance Documentation',
          instructions: 'Navigate to the Compliance Center in CrossRegGuard and review your organization\'s current AML policies. Document any gaps you notice compared to what you learned in this training.',
          question: 'What are 2-3 areas where your organization\'s AML policies could be strengthened based on this training?',
          crossregguardLink: '/app/compliance'
        },
        {
          id: 'task-4',
          title: 'Screen Customer Against Sanctions',
          instructions: 'Using CrossRegGuard\'s sanctions screening tool, perform an OFAC screening on at least 3 customers. Review any matches and determine if they are true positives or false positives based on customer information you have on file.',
          question: 'Which customers did you screen? Were any matches found? If yes, how did you verify whether they were true or false positives?',
          crossregguardLink: '/app/sanctions-screening'
        },
        {
          id: 'task-5',
          title: 'Document Training Completion',
          instructions: 'Complete this hands-on exercise by documenting your key learnings from the AML Foundations training. Summarize the most important concepts and how they apply to your role in compliance.',
          question: 'What were the 3-4 most important AML concepts you learned? How will you apply this knowledge in your compliance responsibilities?',
          crossregguardLink: '/app/compliance'
        }
      ]
    },
    'es': {
      id: 'aml-foundations-hands-on',
      title: 'Ejercicio Práctico de Fundamentos de AML',
      tasks: [
        {
          id: 'task-1',
          title: 'Identificar Patrones de Transacciones Sospechosas',
          instructions: 'Utilizando CrossRegGuard, navega a la página de Monitoreo de Transacciones. Revisa las transacciones de muestra proporcionadas e identifica al menos 2 transacciones que parezcan sospechosas según los indicadores de AML (montos inusuales, movimientos rápidos, jurisdicciones de alto riesgo, etc.).',
          question: '¿Qué IDs de transacción identificaste como sospechosas y cuáles fueron las banderas rojas?',
          crossregguardLink: '/app/transactionmonitoring'
        },
        {
          id: 'task-2',
          title: 'Presentar un Reporte de Actividad Sospechosa',
          instructions: 'Para una de las transacciones sospechosas que identificaste, prepara y presenta un Reporte de Actividad Sospechosa (SAR) utilizando la función de reportes de CrossRegGuard. Incluye detalles sobre la transacción, partes involucradas y las preocupaciones de AML.',
          question: '¿Cuál fue el monto de la transacción, el nombre del cliente y la preocupación principal de AML que reportaste?',
          crossregguardLink: '/app/sar'
        },
        {
          id: 'task-3',
          title: 'Revisar Documentación de Cumplimiento de AML',
          instructions: 'Navega al Centro de Cumplimiento en CrossRegGuard y revisa las políticas de AML actuales de tu organización. Documenta las brechas que notes comparadas con lo que aprendiste en este entrenamiento.',
          question: '¿Cuáles son 2-3 áreas donde las políticas de AML de tu organización podrían fortalecerse según este entrenamiento?',
          crossregguardLink: '/app/compliance'
        },
        {
          id: 'task-4',
          title: 'Examinar Cliente Contra Sanciones',
          instructions: 'Utilizando la herramienta de examen de sanciones de CrossRegGuard, realiza un examen de OFAC en al menos 3 clientes. Revisa cualquier coincidencia y determina si son verdaderos positivos o falsos positivos basándote en la información del cliente que tienes en archivo.',
          question: '¿Qué clientes examinaste? ¿Se encontraron coincidencias? Si es así, ¿cómo verificaste si eran verdaderos o falsos positivos?',
          crossregguardLink: '/app/sanctions-screening'
        },
        {
          id: 'task-5',
          title: 'Documentar Finalización del Entrenamiento',
          instructions: 'Completa este ejercicio práctico documentando tus aprendizajes clave del entrenamiento de Fundamentos de AML. Resume los conceptos más importantes y cómo se aplican a tu rol en cumplimiento.',
          question: '¿Cuáles fueron los 3-4 conceptos de AML más importantes que aprendiste? ¿Cómo aplicarás estos conocimientos en tus responsabilidades de cumplimiento?',
          crossregguardLink: '/app/compliance'
        }
      ]
    },
    'pt': {
      id: 'aml-foundations-hands-on',
      title: 'Exercício Prático de Fundações de AML',
      tasks: [
        {
          id: 'task-1',
          title: 'Identificar Padrões de Transações Suspeitas',
          instructions: 'Utilizando CrossRegGuard, navegue até a página de Monitoramento de Transações. Revise as transações de amostra fornecidas e identifique pelo menos 2 transações que pareçam suspeitas com base em indicadores de AML (valores incomuns, movimentos rápidos, jurisdições de alto risco, etc.).',
          question: 'Quais IDs de transação você identificou como suspeitos e quais foram os sinais de alerta?',
          crossregguardLink: '/app/transactionmonitoring'
        },
        {
          id: 'task-2',
          title: 'Arquivar um Relatório de Atividade Suspeita',
          instructions: 'Para uma das transações suspeitas que você identificou, prepare e arquive um Relatório de Atividade Suspeita (SAR) usando o recurso de relatórios do CrossRegGuard. Inclua detalhes sobre a transação, partes envolvidas e preocupações com AML.',
          question: 'Qual foi o valor da transação, o nome do cliente e a principal preocupação com AML que você relatou?',
          crossregguardLink: '/app/sar'
        },
        {
          id: 'task-3',
          title: 'Revisar Documentação de Conformidade com AML',
          instructions: 'Navegue até o Centro de Conformidade no CrossRegGuard e revise as políticas de AML atuais da sua organização. Documente as lacunas que você notar em comparação com o que aprendeu neste treinamento.',
          question: 'Quais são 2-3 áreas em que as políticas de AML da sua organização poderiam ser fortalecidas com base neste treinamento?',
          crossregguardLink: '/app/compliance'
        },
        {
          id: 'task-4',
          title: 'Rastrear Cliente Contra Sanções',
          instructions: 'Usando a ferramenta de rastreamento de sanções do CrossRegGuard, execute um rastreamento OFAC em pelo menos 3 clientes. Revise qualquer correspondência e determine se são verdadeiros positivos ou falsos positivos com base nas informações do cliente que você possui no arquivo.',
          question: 'Quais clientes você rastreou? Alguma correspondência foi encontrada? Se sim, como você verificou se eram verdadeiros ou falsos positivos?',
          crossregguardLink: '/app/sanctions-screening'
        },
        {
          id: 'task-5',
          title: 'Documentar Conclusão do Treinamento',
          instructions: 'Conclua este exercício prático documentando seus principais aprendizados do treinamento de Fundações de AML. Resuma os conceitos mais importantes e como eles se aplicam ao seu papel em conformidade.',
          question: 'Quais foram os 3-4 conceitos de AML mais importantes que você aprendeu? Como você aplicará esse conhecimento em suas responsabilidades de conformidade?',
          crossregguardLink: '/app/compliance'
        }
      ]
    }
  },
  'kyc': {
    id: 'kyc-hands-on',
    title: 'KYC Hands-On Exercise',
    tasks: [
      {
        id: 'task-1',
        title: 'Complete KYC Onboarding Process',
        instructions: 'Go to the Customer Onboarding page in CrossRegGuard and complete a full KYC onboarding for a new customer. Collect all required documentation (ID, proof of address, beneficial ownership info) and answer all KYC questions.',
        question: 'What customer information did you collect? Did you find any red flags during the onboarding process?',
        crossregguardLink: '/app/onboarding'
      },
      {
        id: 'task-2',
        title: 'Verify Customer Identity',
        instructions: 'Use CrossRegGuard\'s identity verification tools to verify the customer you onboarded. Check their documents, validate their information against external databases, and complete the identity verification workflow.',
        question: 'What verification methods did you use? Were there any discrepancies you discovered?',
        crossregguardLink: '/app/identity-verification'
      },
      {
        id: 'task-3',
        title: 'Update Customer Risk Profile',
        instructions: 'Based on the information gathered, assess the customer\'s risk level (Low/Medium/High) and update their risk profile in CrossRegGuard. Document the factors that influenced your risk assessment.',
        question: 'What risk level did you assign and what were the key factors in your assessment?',
        crossregguardLink: '/app/customer-management'
      }
    ]
  },
  'sanctions': {
    id: 'sanctions-hands-on',
    title: 'Sanctions & OFAC Compliance Hands-On Exercise',
    tasks: [
      {
        id: 'task-1',
        title: 'Run Sanctions Screening',
        instructions: 'Use CrossRegGuard\'s Sanctions Screening tool to screen 3 different customers against OFAC and international sanctions lists. Document any matches found and the risk level assigned.',
        question: 'How many customers did you screen? Were any matches found? If yes, what was the risk level?',
        crossregguardLink: '/app/sanctions-screening'
      },
      {
        id: 'task-2',
        title: 'Review Sanctions Match Results',
        instructions: 'For any sanctions matches found, review the details in CrossRegGuard. Compare the matched names against your customer records and determine if they are true matches or false positives.',
        question: 'Describe the matches you reviewed. Were they true positives or false positives? How did you make this determination?',
        crossregguardLink: '/app/sanctions-screening'
      },
      {
        id: 'task-3',
        title: 'Document Sanctions Findings',
        instructions: 'Create a compliance report documenting your sanctions screening activities, any matches found, and the actions taken. File this report in your organization\'s compliance records.',
        question: 'What did you find in your sanctions screening? What actions did you recommend or take?',
        crossregguardLink: '/app/compliance-reporting'
      }
    ]
  },
  'transaction-monitoring': {
    id: 'tm-hands-on',
    title: 'Transaction Monitoring Hands-On Exercise',
    tasks: [
      {
        id: 'task-1',
        title: 'Set Up Monitoring Rules',
        instructions: 'In CrossRegGuard\'s Transaction Monitoring module, configure monitoring rules for different transaction types (large transfers, rapid movements, high-risk jurisdictions). Set appropriate thresholds and alert levels.',
        question: 'What monitoring rules did you set up? What transaction thresholds and alert levels did you configure?',
        crossregguardLink: '/app/transactionmonitoring'
      },
      {
        id: 'task-2',
        title: 'Investigate Flagged Transactions',
        instructions: 'Review transactions that have been flagged by the monitoring system. For at least 3 flagged transactions, document the reason for the flag and determine if it represents a genuine risk.',
        question: 'Which transactions did you investigate? What were the flags and your assessment of each?',
        crossregguardLink: '/app/transactionmonitoring'
      },
      {
        id: 'task-3',
        title: 'Create Transaction Alert Report',
        instructions: 'Generate an alert report for the transactions you investigated. Include details about the flagged transactions, your risk assessment, and any recommended actions (approve, block, further investigation).',
        question: 'What were your recommendations for each flagged transaction? How would you explain these decisions to compliance leadership?',
        crossregguardLink: '/app/transactionmonitoring'
      }
    ]
  },
  'sar-reporting': {
    id: 'sar-hands-on',
    title: 'Suspicious Activity Reporting Hands-On Exercise',
    tasks: [
      {
        id: 'task-1',
        title: 'Identify SAR-Reportable Activities',
        instructions: 'Review recent transactions in CrossRegGuard and identify activities that meet the SAR reporting threshold. Look for transactions over $5,000 with indicators of suspicious activity.',
        question: 'What transaction(s) did you identify as potentially SAR-reportable? What were the indicators?',
        crossregguardLink: '/app/transactionmonitoring'
      },
      {
        id: 'task-2',
        title: 'Complete SAR Form',
        instructions: 'Using CrossRegGuard\'s SAR filing tool, complete a SAR form for one of the suspicious activities you identified. Include all required information: transaction details, parties involved, narrative description, and suspicious indicators.',
        question: 'Walk through the SAR you filed. What were the key details and what made this activity reportable?',
        crossregguardLink: '/app/sar'
      },
      {
        id: 'task-3',
        title: 'Review SAR Filing Requirements',
        instructions: 'After filing your SAR, review your organization\'s SAR filing timeline and confidentiality procedures. Ensure you understand when and how to file, and the importance of maintaining confidentiality.',
        question: 'What are the SAR filing deadlines? What are the confidentiality requirements your organization follows?',
        crossregguardLink: '/app/sar'
      }
    ]
  }
};
